import "../Stylesheet/Home.css"
import profile from "../Assets/profile.png";
import { FiMail, FiDownload, FiArrowRight } from "react-icons/fi";
import HomeProject from "./HomeProject"
import Skill from "./Skill"
import Certification from "./Certfication";
import Experience from "./Experience";
import { useContext } from "react";
import { LanguageContext } from "../Context/LanguageContext";
import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

export default function Home() {

  const { t, lang } = useContext(LanguageContext);
  const h = t.home;

   const [showArrow, setShowArrow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowArrow(true);
      } else {
        setShowArrow(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div>
        <div className="hero-wrapper">
          <div className="hero-container">

            {/* Avatar */}
            <div className="avatar-box">
              <div className="avatar-ring">
                <img src={profile} alt="profile" />
                <span className="online-dot"></span>
              </div>

              <div className="badge" >
                {h.badge}
              </div>
            </div>

            {/* Text Content */}
            <div className="hero-content">
              <h1 className={lang === "ta" ? "heading-ta" : "heading-en"}>
                {h.greeting} <span>{h.name}</span>
              </h1>

              <p className={lang === "ta" ? "p-ta" : "p-en"}>
                {h.description}
              </p>

              {/* Buttons */}
              <div className="hero-actions">
                <button className="primary-btn">
                  {h.viewPortfolio}  <FiArrowRight />
                </button>

                <div className="btn-flex">
                  <button className="icon-btn">
                    <FiMail />  {h.contact}
                  </button>

                  <button className="icon-btn">
                    <FiDownload /> {h.resume}
                  </button>
                </div>

              </div>
            </div>

          </div>
        </div>
        <Skill />
        <HomeProject />
        <Experience />
        <Certification />
      </div>

      {showArrow && (
        <div className="scroll-top-arrow" onClick={scrollToTop}>
          <FaArrowUp />
        </div>
      )}

    </>
  )
}
